import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../providers/AuthProvider';
import { canBeShowed } from '../utils/utils';

interface PrivateRouteProps {
  children: React.ReactNode;
  permission?: string[];
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, permission = [] }) => {
  const { loggedIn, user } = useAuth();
  const location = useLocation();
  const access = permission ? !!(user && canBeShowed(user, permission)) : true;

  if (loggedIn && access && !!user) {
    return <>{children}</>;
  }

  if (!loggedIn || !access || !!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
};
